import { gql } from '@apollo/client';

export const LOGOUT_MUTATION = gql`
  mutation LogoutMutation($input: LogoutInput) {
    logout(input: $input) {
      success
      message
    }
  }
`;

export interface LogoutInput {
  deviceId?: string | null;
}

export interface LogoutResponse {
  logout: {
    success: boolean;
    message: string;
  };
}

export interface LogoutVariables {
  input?: LogoutInput;
}

